import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ExpiredSessionModalComponent.css";
import { useKeycloak } from "@react-keycloak/web";
import { useDispatch } from "react-redux";
import { hideSessionExpiredModalActionCreator, turnOffLoadingActionCreator } from "../../actions/commonActions";
import { URL_LOGIN } from "../Routes/Location";
import { useHistory } from "react-router-dom";

const ExpiredSessionModalComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();
  const history = useHistory();

  const turnOffLoading = () => {
    dispatch(turnOffLoadingActionCreator());
  };

  const handleRedirectToLogin = () => {
    dispatch(hideSessionExpiredModalActionCreator());
    history.push(URL_LOGIN);
    keycloak.logout();
  };

  useEffect(() => {
    turnOffLoading();
  });

  return (
    <div className="SessionModalBackground">
      <div className="SessionModal">
        <div className={"LoginTextContainer"}>
          <p className={"SessionTitle"}>{t("user.session.expired")}</p>
          <p>{t("user.login.again")}</p>
        </div>
        <div className="LoginButtonContainer">
          <button onClick={handleRedirectToLogin} className="button-focused LoginModalButton">
            {t("user.login")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpiredSessionModalComponent;
